import {wizard} from '@/config/sites'

const navigateToTab = () => {
  window.open(`${wizard.url}/agenti`, '_blank')
}

export default {
  'bindTo': false,
  'method': navigateToTab,
}
